

<template>
  <div>
    <div id="overlay" @click="closeReloadOverlay()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
    <div class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 380px; height: 440px; left: calc((108vw - 500px)/2); top:100px;z-index: 99;">
      <div  class="flex flex-col justify-center px-4 py-2">
        <img src="../../../assets/doc_consultation.svg" style="width:300px;position: absolute;top: 0;left: 42px;">
          <div class="flex flex-row mb-2 justify-between items-center" style="position: absolute;bottom: 94px; left:31%">
              <div class="align-center text-lg text-left font-semibold py-2">You are back online!</div>
          </div>
          <label class="align-center text-grey-darker font-light text-xs mx-8" style="position: absolute; bottom: 74px; left: 10px; text-align:center">
            <img class="w-4 h-5" src="../../../assets/bulb.png" style="position: relative; bottom: -4px;"> 
            {{this.getTips()}}
          </label>
          <div class="flex flex-row mt-3 mb-5 justify-start" style="position: absolute;bottom: 0px; left:31%; margin-left: 38px;">
              <div @click="closeReloadOverlay()" class="flex flex-col bg-blue px-6 py-2 font-semibold justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md">Okay</div>
          </div>
      </div>
    </div>
  </div>  
</template>
<script>
export default {
  methods: {
    closeReloadOverlay: function () {
      this.$emit('close')
    },
    getTips: function () {
      let tips = [
        'Make sure your chat status is "Yes" if you wish to receive patient requests. ',
        'Your connection status must always be in Connected state. ',
        'If your connection status shows "Disconnected" check your internet connectivity.',
        'Make sure you save your consultation summary before sending it to the patient.',
        'Make sure you complete case summaries for all your patients within 24 hours of consultation.',
        'Make sure your system volume is turned on to avoid missing any request notifications.',
        'Remember to end all your consultations before logging out.'
      ]
      var tip = tips[Math.floor(Math.random() * tips.length)]
      return tip
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/modals/BackOnline.vue